import { store } from '@/context/store';

import { lookupNvic } from '../lookupNvic';

export async function lookupVehicle(partnerId: string): Promise<void> {
    const { vin, nvic } = store.getState().borrowerReducer.vehicle;
    const state = store.getState();
    const userFlow = state.displayReducer.partner.userFlow;
    const initialJourney = state.displayReducer.initialJourney;

    // For test drive flow, we don't need to skip lookup even if no VIN/NVIC
    const isTestDriveFlow =
        userFlow === 'TEST_DRIVE' || initialJourney === 'TEST_DRIVE';

    // Skip lookup if there is no NVIC or VIN and partnerId is UNKNOWN or missing
    // But allow for test drive flow with basic vehicle info
    if (
        !vin &&
        !nvic &&
        (!partnerId || partnerId === 'UNKNOWN') &&
        !isTestDriveFlow
    )
        return;

    // We prefer to use NVIC over VIN
    if (nvic) {
        await lookupNvic(partnerId);
        const { glassValuation } = store.getState().borrowerReducer.vehicle;

        // If glassValuation is set, then we have a valid vehicle and VIN is not required
        if (glassValuation) {
            return;
        }
    }

    // For test drive flow, if we have basic vehicle info but no lookup, still mark as known
    if (isTestDriveFlow) {
        const vehicle = store.getState().borrowerReducer.vehicle;
        if (vehicle.make || vehicle.model || vehicle.buildYear) {
            // Vehicle is known from URL parameters
            return;
        }
    }

    return;
}
